
/**
 * Базовый класс для всех терминальных сервисов
 */
export class BaseTerminalService {
    constructor() {
        this.baseUrl = null;
        this.isInitialized = false;
        this.deviceInfo = null;
        this.needsRegistration = false;
        this.initializationPromise = null;
        this.isDeviceAuthorized = false;
    }

    /**
     * Проверка авторизации устройства (должна быть переопределена)
     */
    checkDeviceAuthorization() {
        throw new Error('Method must be implemented by subclass');
    }

    /**
     * Инициализация сервиса (должна быть переопределена)
     */
    async init() {
        throw new Error('Method must be implemented by subclass');
    }

    /**
     * Получение конфигурации терминала из device_register_info
     * @param {Object} deviceInfo - Информация об устройстве
     * @param {string} posType - Тип терминала
     * @returns {Object|null} Конфигурация терминала
     */
    getTerminalConfig(deviceInfo, posType) {
        try {
            if (!deviceInfo || !deviceInfo.payment_methods) {
                return null;
            }

            const paymentMethods = deviceInfo.payment_methods || [];
            const terminalMethod = paymentMethods.find(method => method.pos_type === posType);
            return terminalMethod;
        } catch (error) {
            console.error(`${posType} POS: Error getting terminal config:`, error);
            return null;
        }
    }

    /**
     * Получение информации об устройстве
     */
    async getLocalDeviceInfo() {
        try {
            const { deviceRegisterService } = await import('./posApi');
            const deviceInfo = await deviceRegisterService.getRegisterInfo();
            return deviceInfo;
        } catch (error) {
            console.error('Terminal: Error getting device info from API:', error);

            try {
                const deviceRegisterInfo = localStorage.getItem('device_register_info');
                if (!deviceRegisterInfo) return null;

                const info = JSON.parse(deviceRegisterInfo);
                return info;
            } catch (storageError) {
                console.error('Terminal: Error parsing device info from localStorage:', storageError);
                return null;
            }
        }
    }

    /**
     * Стандартные методы для всех терминалов
     */
    async startPayment(amount, ownCheque = false) {
        throw new Error('Method must be implemented by subclass');
    }

    async startRefund(amount, transactionData, ownCheque = false) {
        throw new Error('Method must be implemented by subclass');
    }

    async getTransactionStatus(processId) {
        throw new Error('Method must be implemented by subclass');
    }

    async monitorTransaction(processId, onStatusUpdate = null) {
        throw new Error('Method must be implemented by subclass');
    }

    // Общие методы для всех терминалов
    destroy() {
        this.initializationPromise = null;
        this.isInitialized = false;
    }

    reset() {
        this.destroy();
        this.baseUrl = null;
        this.deviceInfo = null;
        this.needsRegistration = false;
        this.isDeviceAuthorized = false;
    }

    /**
     * Проверка поддержки возвратов терминалом
     * @returns {boolean} Поддерживает ли терминал возвраты
     */
    supportsRefunds() {
        return true; // По умолчанию поддерживаем
    }

    /**
     * Подготовка данных транзакции для возврата
     * @param {Object} paymentDetails - Детали оригинального платежа
     * @returns {Object} Подготовленные данные для возврата
     */
    prepareRefundData(paymentDetails) {
        // Базовая реализация - каждый терминал может переопределить
        return paymentDetails;
    }
}